import { Session } from '@/types/sessionsList';

export const hasDefualtChatName = (chats: Session[]) => {
  return chats.some((chat) => chat.chat_name === 'New Chat');
};
